// extracted by css-extract-rspack-plugin
export default {"emptyState":"EO3Dv","empyIcon":"t7KBE"};